import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Car } from '../car.model';
import './vehicleDetail.component.scss';

const VehicleDetailComponent = props => {
  const car = props.car;

  const handleDetailClick = () => {
    props.history.push(`/better-fake-vdp/${props.entityId}/${car.id}`);
  };

  if (props.car) {
    return (
      <aside className="vlp-details">
        <header>
          <a href="javacript:void(0);">
            <img src={car.image} alt="car" />
          </a>

          <h2>{car.name}</h2>
          <p>{car.modelDescription}</p>
        </header>

        <section>
          <header>
            <h2>Inventory Deatil</h2>
          </header>

          <dl>
            <dt>VIN:</dt>
            <dd>{car.inventoryDetail.vin}</dd>

            <dt>Stock Number:</dt>
            <dd>{car.inventoryDetail.stockNumber}</dd>

            <dt>Type:</dt>
            <dd>{car.inventoryDetail.type}</dd>

            <dt>Inventory Date:</dt>
            <dd>{car.inventoryDetail.inventoryDate}</dd>
          </dl>
        </section>

        <section>
          <header>
            <h2>Powertrain</h2>
          </header>

          <dl>
            <dt>Engine:</dt>
            <dd>{car.powertrain.engine}</dd>

            <dt>Transmision:</dt>
            <dd>{car.powertrain.transmission}</dd>
          </dl>
        </section>

        <div className="actions">
          <button type="button" className="btn btn-primary" onClick={handleDetailClick}>
            Details
          </button>
        </div>
      </aside>
    );
  } else {
    return <aside style={{ display: 'none' }}>Click on Vechile List to see details.</aside>;
  }
};

VehicleDetailComponent.propTypes = {
  car: PropTypes.instanceOf(Car)
};

export default withRouter(VehicleDetailComponent);



// WEBPACK FOOTER //
// ./src/components/vehicles/detail/vehicleDetail.component.js